import DS from 'ember-data';
import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import IntegrationsReportingWebhooksNewController from 'cio/pods/integrations/reporting-webhooks/new/controller';
import WebhookModel from 'cio/models/webhook';
import ConfirmChangesService from 'cio/services/confirm-changes';

export default class IntegrationsReportingWebhooksNew extends Route {
  @service store!: DS.Store;
  @service confirmChanges!: ConfirmChangesService;

  crumb() {
    return {
      name: 'Add Webhook',
      path: 'integrations.reporting-webhooks.new',
    };
  }

  model() {
    return this.store.createRecord('webhook');
  }

  setupController(controller: IntegrationsReportingWebhooksNewController, model: WebhookModel, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.fetchWebhooks.perform();

    this.confirmChanges.register(controller, this);
  }
}
